import $ from "jquery"
import ForgeryProtection from "lib/ForgeryProtection"
import { isSessionActive } from "lib/currentUser/session"

// Adds the CSRF token to same-origin jQuery requests, once we have one.
//
// This has a known race condition: a request that needs the token will be
// missing it if it's sent before the token request finishes.
export default function addCSRFTokenToAjaxRequests() {
  return ForgeryProtection.CSRF.then(({ token }) => {
    $.ajaxPrefilter((options, originalOptions, xhr) => {
      if (!options.crossDomain) {
        xhr.setRequestHeader("X-CSRF-Token", token)
      }
    })
  })
}

// For pages the CDN caches, where readers with no session can't send a jQuery
// write. Skipping the token saves a request to Rails on each of their page
// views. Anything else that needs a token awaits ForgeryProtection.CSRF.
export function addCSRFTokenToAjaxRequestsWithSession() {
  if (isSessionActive()) {
    return addCSRFTokenToAjaxRequests()
  }
}
